export const getIntialValues = (data = {}) => {
  return {
    meta_seo: {
      meta_title: data?.meta_seo?.meta_title || "",
      meta_keyword: data?.meta_seo?.meta_keyword || "",
      meta_desc: data?.meta_seo?.meta_desc || "",
    },
    header: {
      primary_heading: data?.header?.primary_heading || "",
      secondary_heading: data?.header?.secondary_heading || "",
      description: data?.header?.description || "",
    },

    banners: data?.banners?.length ? data.banners : [{ title: "", description: "", cta_label: "", icon: "", cta_redirect_link: "" , alt_tag:"",}],

    learning_platform: {
      title: data?.learning_platform?.title || "",
      add_ons: data?.learning_platform?.add_ons?.length ? data.learning_platform.add_ons : [{ image_url: "", alt_tag: "" }],
    },
  };
};

export const generatePayload = (values) => {
  return {
    meta_seo: {
      meta_title: values?.meta_seo?.meta_title || "",
      meta_keyword: values?.meta_seo?.meta_keyword || "",
      meta_desc: values?.meta_seo?.meta_desc || "",
    },
    header: {
      primary_heading: values?.header?.primary_heading || "",
      secondary_heading: values?.header?.secondary_heading || "",
      description: values?.header?.description || "",
    },

    banners: values?.banners?.length ? values.banners : [{ title: "", description: "", cta_label: "", icon: "", cta_redirect_link: "" , alt_tag:"", }],

    learning_platform: {
      title: values?.learning_platform?.title || "",
      add_ons: values?.learning_platform?.add_ons?.length ? values.learning_platform.add_ons : [{ image_url: "", alt_tag: "" }],
    },
  };
};
